<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div ref="wyPageModal" class="wy-page-modal-wrapper">
    <transition name="wy-page-modal" v-if="showModal">
      <div class="wy-page-modal">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'wy-page-modal',
  props: ['onOpen', 'onClose', 'closeOnClick', 'onPageClick'],

  data() {
    return {
      showModal: false
    }
  },

  methods: {
    handleClick(e) {
      e.stopPropagation();
      if(this.onPageClick) {
        this.onPageClick(e)
      } 
    },

    open() {
      this.showModal = true;
      if(this.onOpen) this.onOpen();
    },

    close() {
      this.showModal = false;
      if(this.onClose) this.onClose();
    }
  },

  mounted() {
    // register modal click event to stop bubble up event
    this.$refs.wyPageModal.addEventListener('click', this.handleClick);
    
    // add outside click event to close the modal
    if(this.closeOnClick && document.querySelector(".el-main.wy-container-main")) {
      document.querySelector(".el-main.wy-container-main").addEventListener('click', () => { 
        this.close();
      });
    }
  },

  beforeDestroy() {
    this.$refs.wyPageModal.removeEventListener('click', this.handleClick);
  }
}
</script>

<style lang="scss">
.wy-page-modal {
  position: absolute;
  top: 0;
  left: -6px;
  padding-left: 6px;
  border: 0px solid red;
  width: 100%;
  height: 110%;
  overflow-y: hidden;
  overflow-x: auto;
  background-color: #FCFCFC;
  z-index: 9;
  /*transition: opacity 1.3s ease;

  .wy-page-modal-enter {
    opacity: 0;
  }

  .wy-page-modal-leave-active {
    opacity: 0;
  }*/
}
</style>
